<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br/>
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br>
            {{ userStore.user.dob }}
            <br>
            {{ userStore.user.ssn }}
            <br>
            <br>
            " court.name "
            <br>
            " court.address "
            <br>
            <br>
            Date: {{ date }}
            <br>
            <br>
            <template>
                RE: Reporting To The { court.name }
            </template>
            <br>
        </p>
        <p>
            Dear Clerk:
        </p>
        <p class="letter-content">
        My name is {{ userStore.user.firstname }} {{ userStore.user.lastname }} and I am writing to you because this entry: { accountNumber } is appearing on my credit report which states that I filed bankruptcy in your
            court. Could you please explain to me how this might occur? From my understanding, only the last four digits of a
            debtor’s social security number are released to third parties, under the Federal Rules of Bankruptcy Procedure.
        </p>
        <p class="letter-content">
        Finally, does this court release information about debtor bankruptcies to third parties such as LexisNexis, TransUnion,
        Experian, or Equifax? Any information you can provide me would be appreciated.
        </p>
        <p class="letter-content">
            Thank you for your time and help in this matter.
        </p>
        <p style="page-break-after: always;">
            Sincerely, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>
